document.addEventListener("DOMContentLoaded", ()=>{
    const collapseElems =document.querySelectorAll("button.collapsable-toggler");

    collapseElems.forEach(
        collapseBlock => {
            collapseBlock.addEventListener('click', (e)=>{
                const targetEvent = e.currentTarget;    

                const contentPanelElem = document.getElementById(`${targetEvent.dataset.toggle}`);

                if( contentPanelElem ){
                    const expanded = targetEvent.getAttribute("aria-expanded");

                    if( expanded == "true"){
                        contentPanelElem.classList.remove('show');
                        targetEvent.setAttribute("aria-expanded", "false");
                    } else {
                        contentPanelElem.classList.add('show');
                        targetEvent.setAttribute("aria-expanded", "true");
                    }
                }
            });
        }

    );

})